import { Constants } from '.'

const initialState = {
  get: {
    isRequest: true,
    payload: {},
    error: {}
  }
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case Constants.USER_GET:
      return {
        ...state,
        get: {
          ...state.get
        }
      }

    case Constants.USER_GET_SUCCESS:
      return {
        ...state,
        get: {
          ...state.get,
          isRequest: false,
          payload: action.payload
        }
      }

    case Constants.USER_GET_FAILURE:
      return {
        ...state,
        get: {
          ...state.get,
          isRequest: false,
          error: action.error
        }
      }

    case Constants.USER_SET_PROFILE_PREFERENCES:
      return {
        ...state,
        get: {
          ...state.get
        }
      }

    case Constants.USER_SET_PROFILE_PREFERENCES_SUCCESS:
      return {
        ...state,
        get: {
          ...state.get,
          payload: { ...state.get.payload, hasPreferences: true }
        }
      }

    case Constants.USER_SET_PROFILE_PREFERENCES_FAILURE:
      return {
        ...state,
        get: {
          ...state.get,
          error: action.error
        }
      }

    default:
      return state
  }
}
